<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 8.33335L3.71733 11.0507C3.79233 11.1256 3.894 11.1677 4 11.1677C4.106 11.1677 4.20767 11.1256 4.28267 11.0507L6 9.33335M10.6667 4.66669L8 7.33335"
      stroke="var(--svg-col, #009E50)"
      stroke-width="1.5"
      stroke-linecap="round" />
    <path
      d="M4.6665 8.00002L7.71717 11.0507C7.79217 11.1256 7.89384 11.1677 7.99984 11.1677C8.10584 11.1677 8.2075 11.1256 8.2825 11.0507L14.6665 4.66669"
      stroke="var(--svg-col, #009E50)"
      stroke-width="1.5"
      stroke-linecap="round" />
  </svg>
</template>
